import { render } from "./AccountPage.vue?vue&type=template&id=bab58a0e&ts=true"
import script from "./AccountPage.vue?vue&type=script&lang=tsx"
export * from "./AccountPage.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__